import { callPostApi, callPutApi, callGetApi } from "./api";

export async function todaysDetails() {
      try {
            const response = await callGetApi({ url: "clocks/details" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getClockDetailsById(id) {
      try {
            const response = await callGetApi({ url: 'clocks/' + id + '/change-request' });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function usersAdminHistory(data) {
      try {
            const response = await callPostApi({ url: "clocks/admin", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function exportTimeHistory(data) {
      try {
            const response = await callPostApi({ url: "clocks/admin/export", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getUserHistory() {
      try {
            const response = await callGetApi({ url: 'clocks' });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function details(id) {
      try {
            const response = await callGetApi({ url: 'clocks/' + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function edit(data) {
      try {
            const response = await callPutApi({ url: "clocks", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function clockInOut(data) {
      try {
            const response = await callPostApi({ url: "clocks", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function continueBreak() {
      try {
            const response = await callGetApi({ url: 'clocks/continue' });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function applyChangeRequest(data) {
      try {
            const response = await callPostApi({ url: "change-request", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateChangeRequest(data) {
      try {
            const response = await callPutApi({ url: "change-request", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function clockedInCount(data) {
      try {
            const response = await callPostApi({ url: "clocks/count", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCheckInOutEntry(data){
      try{
            const response = await callPostApi({url: "clocks/update_clock_data",body: data});
            return response;
      }catch(error){
            throw error;
      }
}

export async function addClockDay(data){
      try{
            const response = await callPostApi({url: "clocks/admin/add-day",body: data});
            return response;
      }catch(error){
            throw error;
      }
}

export async function timeClockAuditTrail(data){
      try{
            const response = await callPostApi({url: "clocks/audit_trail_timeclock_list",body: data});
            return response;
      }catch(error){
            throw error;
      }
}

export async function timeClockAuditTrailDetails(id){
      try{
            const response = await callGetApi({url: "clocks//audit_trail_timeclock_details/" + id});
            return response;
      }catch(error){
            throw error;
      }
}